// Components
import SyncCalendarStep from './steps/SyncCalendarStep';
import GiveKudosStep from './steps/GiveKudosStep';
import AddIntegrationsStep from './steps/AddIntegrationsStep';
import SetupGroupWorkspaceStep from './steps/SetupGroupWorkspaceStep';
import UpdateYourProfileStep from './steps/UpdateYourProfileStep';
import DismissStep from './steps/DismissStep';

export enum QuickStartGuideItemIDs {
  addDiscussionTopics = 'add-discussion-topics',
  syncCalendar = 'sync-calendar',
  giveKudos = 'give-kudos',
  addIntegrations = 'add-integrations',
  setupGroupWorkspace = 'setup-group-workspace',
  updateYourProfile = 'update-your-profile',
  dismiss = 'dismiss',
}
export const QuickStartGuideItems = [
  {
    id: QuickStartGuideItemIDs.syncCalendar,
    title: 'Sync calendar',
    description: 'Connect your workspaces to calendar events to keep notifications relevant and timely.',
    icon: '📆',
    component: SyncCalendarStep,
  },
  {
    id: QuickStartGuideItemIDs.giveKudos,
    title: 'Give kudos',
    description: 'Kudos are like a virtual high five. Give one now for a job well done.',
    icon: '🌈',
    component: GiveKudosStep,
  },
  {
    id: QuickStartGuideItemIDs.addIntegrations,
    title: 'Add Integrations',
    description: 'Add integrations you already use  to streamline the meeting experience',
    icon: '🔌',
    component: AddIntegrationsStep,
  },
  {
    id: QuickStartGuideItemIDs.setupGroupWorkspace,
    title: 'Set up  a Group Workspace',
    description: 'Group workspaces help teams run successful meetings with clear agendas and action items.',
    icon: '🙌',
    component: SetupGroupWorkspaceStep,
  },
  {
    id: QuickStartGuideItemIDs.updateYourProfile,
    title: 'Update your profile',
    description: 'Add a profile photo and set your department to help things run more smoothly',
    icon: '😉',
    component: UpdateYourProfileStep,
  },
  {
    id: QuickStartGuideItemIDs.dismiss,
    title: 'Dismiss',
    description:
      'Not interested in using the quickstart guide? No problem. Dismiss it for good and we’ll get it out of your way.',
    button: true,
    component: DismissStep,
  },
];
